import { useCallback, useState } from 'react'
import styled from 'styled-components'
import { useDownload, useLocalizedTechSheet } from './_methods'
import TechListPreviewDesktop from './TechListPreviewDesktop'
import TechListPreviewMobile from './TechListPreviewMobile'
import Select from './Select'
import NotAvailable from './NotAvailable'
import TechListPrint from 'components/Common/TechListPrint'
import Notify from 'components/Common/Notify'
import useScreen from 'utils/screen'

export const TechSheetPrintContainer = styled.div`
  min-width: 1240px;
  width: 1240px;
  z-index: -100;
  position: fixed;
  background-color: white;
  right: 100px;
  top: 500px;
  transform: translate(-1000%, 0);

  /* debug */
  /*
  z-index: 9999999;
  right: unset;
  left: 0;
  top: 0;
  */
`

const ViewPdf = ({ productId, currentLngProductData }) => {
  const [localeId, setLocaleId] = useState(null)

  const { data: techSheetData, loading: isTechSheetLoading } =
    useLocalizedTechSheet(productId, localeId, currentLngProductData)

  const staticTechSheets = Array.isArray(
    currentLngProductData?.wine?.techSheets
  )
    ? currentLngProductData.wine.techSheets.map(ts => ({
        id: String(ts.locale?.id),
        localeId: ts.locale?.id,
        locale: ts.locale?.locale,
        name: ts.locale?.localizedName,
      }))
    : undefined

  const handleSelect = localeId => {
    setLocaleId(localeId)
  }

  const { isMobile } = useScreen()

  const TechListModal = isMobile
    ? TechListPreviewMobile
    : TechListPreviewDesktop

  const [printRef, setPrintRef] = useState({ current: null })
  const { isDownloading, download, error } = useDownload()

  const handleSetPrintRef = useCallback(node => {
    setPrintRef({ current: node })
  }, [])

  const locale = techSheetData?.wine?.techSheet?.locale?.locale

  const closeModal = () => {
    if (!isDownloading) {
      setLocaleId(null)
    }
  }

  return (
    <>
      {productId ? (
        <Select
          productId={productId}
          onSelectLang={handleSelect}
          loading={isMobile && (isDownloading || isTechSheetLoading)}
          staticTechSheets={staticTechSheets}
        />
      ) : (
        <NotAvailable />
      )}

      {localeId && (
        <>
          <TechListModal
            close={closeModal}
            data={techSheetData}
            loading={isTechSheetLoading}
            isDownloading={isDownloading}
            download={download}
            lng={locale}
            printRef={printRef}
          />

          <TechSheetPrintContainer>
            <TechListPrint
              product={techSheetData}
              lng={locale}
              ref={handleSetPrintRef}
            />
          </TechSheetPrintContainer>
        </>
      )}

      {error && <Notify text={error} color='#d00a00' />}
    </>
  )
}

export default ViewPdf
